<template>
  <div class="InputMail" :class="hasChanged ? isCorrect ? 'InputMail--valid': 'InputMail--error' : ''">
    <div class="InputMail-container">
      <div class="Form-row">
        <input 
          class="InputMail-input Form-input"
          :class="{ 'InputMail-input--valid' : hasChanged && isCorrect , 'InputMail-input--error' : hasChanged && !isCorrect, 'hasValue': this.inputValue.length}"
          type="text"
          :name="`InputMail-${answer.id}`"
          :id="`InputMail-${answer.id}`"
          @keyup="isCorrectValue"
          :required="answer.required"
        />
        <label class="Form-label" :for="`InputMail-${answer.id}`">{{ this.answerLabel }}</label>

        <FormInputIcon
          :isLoading="false"
        />
        
      </div>
      <div class="InputMail-message">L'adresse email ne peut pas être vide et doit être au format exemple@domaine.fr</div>
    </div>
  </div>
</template>

<script>

import FormInputIcon from "../FormInputIcon/FormInputIcon.vue"

export default {
  name: "InputMail",
  props: {
    answer: {
      required: true,
      type: Object
    }
  },
  components: {
    FormInputIcon
  },
  data() {
    return {
      answerLabel: this.answer.required ? this.answer.label + ' *' : this.answer.label,
      regexName: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
      inputValue: '',
      hasChanged: false
    }
  },
  computed: {
    isCorrect() {
      return  this.inputValue !== '' && this.regexName.test(this.inputValue)
    }
  },
  methods: {
    isCorrectValue(event) {
      this.hasChanged = true
      const input = event.target
      this.inputValue = input.value

      let toEmit = {"questionId": this.answer.id, "questionLabel": this.answer.label, "questionValue" : '' , "questionIdentifier" : this.answer.identifier}
      
      if(this.isCorrect){
        toEmit.questionValue = this.inputValue
      }

      this.$emit('InputMail::set-data', toEmit)
    },
  },
}
</script>